<template>
  <div class="root">
    <div class="page-header">
      <button class="btn back-btn" @click="navigateBack">
        <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.69945 0.366117C9.18761 -0.122039 9.97887 -0.122039 10.467 0.366117C10.9552 0.854272 10.9552 1.64554 10.467 2.13369L3.01748 9.58324L10.467 17.0328C10.9552 17.5209 10.9552 18.3122 10.467 18.8004C9.97887 19.2885 9.18761 19.2885 8.69945 18.8004L0.366117 10.467C-0.122039 9.97887 -0.122039 9.1876 0.366117 8.69945L8.69945 0.366117Z" fill="black"/>
        </svg>
      </button>
      <div class="page-title">คะแนนแลกคูปอง</div>
    </div>

    <div class="coupon-grid">
      <div class="coupon-grid-item" v-for="(coupon, index) in coupons" :key="`coupon-${index}`">
        <CouponCard :coupon="coupon" @select="viewCouponDetails" />
      </div>
    </div>
  </div>
</template>

<script>
import CouponCard from '@/components/CouponCard.vue'

export default {
  name: 'couponsPage',
  components: {
    CouponCard,
  },
  computed: {
    coupons() {
      return this.$store.state.rewards.data?.filter((rw) => rw.categoryId === 24) || []
    },
  },
  methods: {
    navigateBack() {
      this.$router.back()
    },
    viewCouponDetails(coupon) {
      this.$router.push(`/coupon/${coupon.id}`)
    },
  },
  mounted() {
    window.loading(false)
  },
}
</script>

<style scoped>
.root {
  padding: 16px;
  background: #fff;
  min-height: 100vh;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.back-btn {
  padding: 0;
}

.page-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #000;
}

.coupon-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.coupon-grid-item {
  min-width: 0;
}
</style>
